<template>
  <v-dialog max-width="500" content-class="player-props-widget-dialog" persistent v-model="playerPropsData">
    <div class="close-btn">
      <button @click="closePlayerPropsDialog" class="close" v-html="$t('PlayerProps.Widget.Close')"></button>
    </div>
    <v-card v-if="playerPropsData && playerPropsData.markets[0].selections" class="player-props-w">
      <player-props-widget :isDialog="true" :event="playerPropsData"></player-props-widget>
    </v-card>
  </v-dialog>
</template>

<script>

import store from '@/store'
import BettingOffer from '@/components/mixins/BettingOffer'
import PlayerPropsWidget from './PlayerPropsWidget.vue'

export default {
  name: 'PlayerPropsDialog',
  components: { PlayerPropsWidget },
  mixins: [
    BettingOffer
  ],
  computed: {
    playerPropsDialogState () {
      return store.getters['overlayState/getPlayerPropsDialogState']
    },
    playerPropsData () {
      return this.playerPropsDialogState || false
    }
  },
  methods: {
    closePlayerPropsDialog () {
      store.dispatch('overlayState/deactivatePlayerPropsDialogData', false)
    }
  },
  mounted () {}
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"

>>>.player-props-widget-dialog
  border-radius var(--player-props-widget-border-radius)
  .view-more
    display none
  .close-btn
    display flex
    justify-content flex-end
    background transparent
    .close
      font-family: 'Roboto Condensed'
      font-size: 14px
      font-weight: 400
      line-height: 16.41px
      margin-right 10px
      color var(--player-props-widget-dialog-close-color)
      background var(--player-props-widget-dialog-close-bgr)
      border-top-left-radius var(--player-props-widget-border-radius)
      border-top-right-radius var(--player-props-widget-border-radius)
      width 15%
      height 30px
      display: flex
      justify-content: center
      align-items: center
  .player-props-w
    display flex
    width 100%
    border-radius var(--player-props-widget-border-radius)
    background transparent
    //min-height 350px
    .props-container
      width 100%
      background var(--player-props-content-bgr)
      color var(--player-props-widget-content-color)
      border-radius var(--player-props-widget-border-radius)
      overflow hidden
      display flex
      flex-direction column
      .props-holder
        .header-title
          margin-bottom 5px
      .props-holder
        cursor: pointer
        padding 20px
        border-top-left-radius var(--player-props-widget-border-radius)
        border-top-right-radius var(--player-props-widget-border-radius)
        background: var(--player-props-widget-header-bgr)
        color var(--player-props-widget-header-color)
        font-size 15px
        font-family: 'Roboto Condensed Bold'
        line-height 17.58px
        display flex
        flex-direction column
        justify-content flex-end
        .time
          color var(--player-props-widget-header-color-time-date)
        .title-wrapper
          display flex
          align-items center
          justify-content space-between
          .away
            display flex
            flex-direction column
            align-items flex-end
            gap 4px
            .logo
              flex none
      .content-wrapper
        display flex
        flex-direction column
        overflow hidden
        flex 1
        background var(--player-props-content-bgr)
        color var(--player-props-widget-content-color)
        padding 10px

</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsDialog.vue